<script setup lang="ts">
const { t } = useI18n();

useSeoMeta({
  title: t('seo.contact.title'),
  description: t('seo.contact.description'),
});
</script>

<template>
  <div class="relative pt-24">
    <main class="my-14 xl:my-48">
      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="mx-auto max-w-2xl space-y-16 divide-y divide-gray-100 lg:mx-0 lg:max-w-none">
          <div class="grid grid-cols-1 gap-10 lg:grid-cols-3">
            <div>
              <h1 class="font-serif text-4xl font-semibold text-gray-900">
                {{ $t('contact.title') }}
              </h1>
              <p class="mt-4 text-base/7 text-gray-600" />
            </div>
            <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:col-span-2 lg:gap-8">
              <div class="rounded-2xl bg-black/5 p-10">
                <h3 class="text-base/7 font-semibold text-gray-900">
                  {{ $t('contact.customerService') }}
                </h3>
                <dl class="mt-3 space-y-1 text-sm/6 text-gray-600">
                  <div>
                    <dt class="sr-only">
                      Email
                    </dt>
                    <dd>
                      <a
                        class="font-semibold text-primary-600"
                        href="mailto:support@contrat-ia.com"
                      >support@contrat-ia.com</a>
                    </dd>
                  </div>
                </dl>
              </div>
              <div class="rounded-2xl bg-black/5 p-10">
                <h3 class="text-base/7 font-semibold text-gray-900">
                  {{ $t('contact.press') }}
                </h3>
                <dl class="mt-3 space-y-1 text-sm/6 text-gray-600">
                  <div>
                    <dt class="sr-only">
                      Email
                    </dt>
                    <dd>
                      <a
                        class="font-semibold text-primary-600"
                        href="mailto:press@contrat-ia.com"
                      >press@contrat-ia.com</a>
                    </dd>
                  </div>
                </dl>
              </div>
              <div class="rounded-2xl bg-black/5 p-10">
                <h3 class="text-base/7 font-semibold text-gray-900">
                  {{ $t('contact.joinTeam') }}
                </h3>
                <dl class="mt-3 space-y-1 text-sm/6 text-gray-600">
                  <div>
                    <dt class="sr-only">
                      Email
                    </dt>
                    <dd>
                      <a
                        class="font-semibold text-primary-600"
                        href="mailto:careers@contrat-ia.com"
                      >careers@contrat-ia.com</a>
                    </dd>
                  </div>
                </dl>
              </div>
              <div class="rounded-2xl bg-black/5 p-10">
                <h3 class="text-base/7 font-semibold text-gray-900">
                  {{ $t('contact.sayHello') }}
                </h3>
                <dl class="mt-3 space-y-1 text-sm/6 text-gray-600">
                  <div>
                    <dt class="sr-only">
                      Email
                    </dt>
                    <dd>
                      <a
                        class="font-semibold text-primary-600"
                        href="mailto:hello@contrat-ia.com"
                      >hello@contrat-ia.com</a>
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
          <div class="grid grid-cols-1 gap-10 pt-16 lg:grid-cols-3">
            <div>
              <h2 class="font-serif text-4xl font-semibold text-gray-900">
                {{ $t('contact.addresses') }}
              </h2>
              <p class="mt-4 text-base/7 text-gray-600" />
            </div>
            <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:col-span-2 lg:gap-8">
              <div class="rounded-2xl bg-black/5 p-10">
                <h3 class="text-base/7 font-semibold text-gray-900">
                  Paris
                </h3>
                <address class="mt-3 space-y-1 text-sm/6 not-italic text-gray-600">
                  <p>26 Rue Damremont</p>
                  <p>Paris, 75018</p>
                </address>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <LandingEndCta class="pt-24" />
  </div>
</template>
